// src/firebase.ts
// ============================================================================
// FILE ROLE: Firebase initialization and configuration
//
// TRUST BOUNDARY: public/unauth (Firebase config is public, auth handled separately)
//
// INPUTS:
//   - Environment variables: VITE_FIREBASE_* (API key, project ID, etc.)
//
// OUTPUTS:
//   - Initialized Firebase app instance
//   - Firebase Messaging instance (for push notifications)
//
// DEPENDENCIES:
//   - firebase/app (Firebase core SDK)
//   - firebase/messaging (Cloud Messaging SDK)
//
// SECURITY NOTES:
//   - Firebase config (apiKey, projectId, etc.) is public and safe to expose
//   - Security rules are enforced server-side in Firebase Console
//   - Never store sensitive data in Firebase without proper rules
//
// TODO(REL): Add error handling for Firebase init failures — prevents silent failures —
//           catch and log initialization errors
// ============================================================================

import { initializeApp } from "firebase/app";
import { getMessaging } from 'firebase/messaging';

// ============================================================================
// FIREBASE CONFIGURATION
// ============================================================================
// All values come from environment variables (safe to expose client-side)
// Security rules must be configured in Firebase Console
// ============================================================================
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// ============================================================================
// FIREBASE INITIALIZATION
// ============================================================================
const app = initializeApp(firebaseConfig);

// Messaging: For push notifications (matches, secret admirers, etc.)
// NOTE: Foreground message handler is in main.tsx (centralized notification logic)
const messaging = getMessaging(app);

// ============================================================================
// EXPORTS
// ============================================================================
export { app, messaging };